// UI-5: each task type as the Type dropdown shows it: an icon tile, a label and a pastel. The
// type lists (utils/constants.js) carry the emoji inside the label ("💰 Accounts"); this splits
// it off, and adds the pastel from the Add task mockup (Business) or the same family (Personal).
const COLORS = {
  Accounts: 'pastel-yellow', Admin: 'pastel-neutral', General: 'pastel-neutral', Authorisation: 'pastel-periwinkle',
  Content: 'pastel-pink', Emails: 'pastel-blue', Family: 'pastel-coral', 'Follow-up': 'pastel-yellow', Health: 'pastel-coral',
  Invoices: 'pastel-mint', Meeting: 'pastel-blue', Operations: 'pastel-orange', Personal: 'pastel-lilac', Planning: 'pastel-periwinkle',
  'PR/Media': 'pastel-green', Product: 'pastel-blue', Reporting: 'pastel-mint', Sick: 'pastel-coral', Strategy: 'pastel-green',
  Team: 'pastel-lilac', 'Thinking Time': 'pastel-pink', Travel: 'pastel-blue', Vacation: 'pastel-yellow',
  // Personal
  Task: 'pastel-neutral', Chore: 'pastel-mint', Appointment: 'pastel-coral', Club: 'pastel-green', School: 'pastel-blue',
  Errand: 'pastel-yellow', Event: 'pastel-pink', Birthday: 'pastel-lilac', Holiday: 'pastel-yellow', 'Date Night': 'pastel-periwinkle',
};

// "💰 Accounts" → { icon: '💰', label: 'Accounts' }. A label with no leading emoji keeps 📋.
export function splitTypeLabel(label = '') {
  const m = /^(\S+)\s+(.+)$/.exec(String(label).trim());
  if (m && /\p{Extended_Pictographic}/u.test(m[1])) return { icon: m[1], label: m[2] };
  return { icon: '📋', label: String(label) };
}

export function taskTypeOptions(types = []) {
  return types.map((t) => ({ value: t.value, ...splitTypeLabel(t.label), color: COLORS[t.value] || 'pastel-neutral' }));
}
